import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';
import { oldNetworkVersion } from 'utils/settings';
import { modalActionBody } from 'components/common/Elements/NewModal/newModal';

export const getRestartOptions = (
  network,
  setAction,
  showProgressBar,
  role,
  actionName,
  title,
  startAction
) => {
  const { t } = useTranslation(['activity']);
  let dropdown = [];
  if (network.networkVersion === oldNetworkVersion) {
    dropdown.push({
      isDisabled: showProgressBar,
      label: (
        <span
          dangerouslySetInnerHTML={{
            __html: t('activity:cm.ACTION-MIGRATE-BOLD')
          }}
        />
      ),
      handleClick: () => {
        if (!showProgressBar) {
          setAction({
            actionName: t('activity:cm.ACTION-MIGRATE'),
            actionKey: 'migrate'
          });
        }
        modalActionBody({
          title: t('activity:cm.ACTION-MIGRATE'),
          callBack: () => startAction({ actionName, actionKey: 'migrate' }),
          text: t('activity:modalText.NETWORK_ACTION_CONFIRM', {
            actionName: t('activity:cm.ACTION-MIGRATE'),
            text: title
          })
        });
      }
    });
  }

  dropdown.push(
    {
      isDisabled: showProgressBar,
      label: t('activity:cm.ACTION-NETWORK-UPGRADE'),
      handleClick: () => {
        if (!showProgressBar) {
          const act = {
            actionName: t('activity:cm.ACTION-NETWORK-UPGRADE'),
            actionKey: 'network-upgrade',
            requiresVersion: true
          };
          setAction(act);
          startAction(act);
        }
      }
    },
    {
      isDisabled: showProgressBar,
      label: t('activity:cm.ACTION-NETWORK-REBUILD'),
      handleClick: () => {
        if (!showProgressBar) {
          setAction({
            actionName: t('activity:cm.ACTION-NETWORK-REBUILD'),
            actionKey: 'network-rebuild'
          });

          modalActionBody({
            title: t('activity:cm.ACTION-NETWORK-REBUILD'),
            callBack: () =>
              startAction({ actionName, actionKey: 'network-rebuild' }),
            text: t('activity:modalText.NETWORK_ACTION_CONFIRM', {
              actionName: t('activity:cm.ACTION-NETWORK-REBUILD'),
              text: title
            })
          });
        }
      }
    },
    {
      isDisabled: showProgressBar,
      label: t('activity:cm.ACTION-NETWORK-AUTOMATIC-UPDATE'),
      handleClick: () => {
        if (!showProgressBar) {
          const act = {
            actionName: t('activity:cm.ACTION-NETWORK-AUTOMATIC-UPDATE'),
            actionKey: 'network-automatic-update',
            requiresVersion: true
          };
          setAction(act);
          startAction(act);
        }
      }
    }
  );

  return dropdown;
};

export const getRequestBody = (networkId, customerId, action) => {
  const requestBody = {
    customerId,
    networkId
  };
  if (!isEmpty(action)) {
    requestBody.action = action.actionKey;
    if (action.version) {
      requestBody.version = action.version;
    }
    if (action.gradual) {
      requestBody.gradual = action.gradual;
    }
  }
  return requestBody;
};
